import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
} from "@mui/material";
import useDisclaimerFormData from "../../../hooks/useDisclaimerFormData";

const DisclaimerFormModal = ({ open, onClose, onSave, disclaimer }) => {
  const { formData, handleChange, handleSubmit, loading } =
    useDisclaimerFormData(disclaimer, onClose, onSave);

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>
        {disclaimer ? "Edit Disclaimer" : "Add Disclaimer"}
      </DialogTitle>
      <DialogContent>
        <TextField
          fullWidth
          margin="dense"
          label="Internal Name"
          value={formData.name}
          onChange={handleChange("name")}
          required
        />
        <TextField
          fullWidth
          margin="dense"
          label="Display Name"
          value={formData.displayName}
          onChange={handleChange("displayName")}
          required
        />
        <TextField
          fullWidth
          margin="dense"
          label="Text"
          value={formData.text}
          onChange={handleChange("text")}
          multiline
          rows={4}
          required
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={loading}>
          Cancel
        </Button>
        <Button
          variant="contained"
          color="primary"
          onClick={handleSubmit}
          disabled={loading}>
          {loading ? "Saving..." : disclaimer ? "Update" : "Create"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DisclaimerFormModal;
